import { render } from "./QuestionList.vue?vue&type=template&id=3b8f27fa"
import script from "./QuestionList.vue?vue&type=script&lang=js"
export * from "./QuestionList.vue?vue&type=script&lang=js"
script.render = render

export default script